import { render } from "./ProductsReportComponent.vue?vue&type=template&id=ed152b8e"
import script from "./ProductsReportComponent.vue?vue&type=script&lang=js"
export * from "./ProductsReportComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/productsReport/ProductsReportComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ed152b8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed152b8e', __exports__)) {
    api.reload('ed152b8e', __exports__)
  }
  
  module.hot.accept("./ProductsReportComponent.vue?vue&type=template&id=ed152b8e", () => {
    api.rerender('ed152b8e', render)
  })

}


export default __exports__